//请自行添加语言资源
const landSalesVerification = {
  beginTime:'开始日期',
  endTime:'结束日期',
  idCardName:'经纪人',
  idCardNo:'身份证号',
  totalMuNum:'土地承包证吨数',
  totalUseMuNum:'已售粮数量',
  totalResidueMuNum:'剩余可结算吨数（净重）',
};
export default landSalesVerification



// WEBPACK FOOTER //
// ./src/page/report/landSalesVerification/lang/landSalesVerification.en.js